// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1___5038aadc6451c489eb6","cls2":"ToolsMenu-cls2___15993318cf5abb52556 ToolsMenu-cls1___5038aadc6451c489eb6"};